import cars from '../images/cars.png';
import { Grid, Button } from '@mui/material';
import CarRentalIcon from '@mui/icons-material/CarRental';
import blob from '../images/blob.png'
import CarRentalOutlinedIcon from '@mui/icons-material/CarRentalOutlined';
import PhoneForwardedOutlinedIcon from '@mui/icons-material/PhoneForwardedOutlined';
import MinorCrashOutlinedIcon from '@mui/icons-material/MinorCrashOutlined';
const Choose = () => {
    return (
        <div className="container">
            <div className="choose-container" style={{ textAlign: "center " }}>
                <div className="choose-container__img">
                    <img src={cars} width="100%" />
                </div>
                <Grid container sx={{ textAlign: "left" }} justifyContent={"space-between"}>
                    <Grid item xs={12} sm={5}>
                        <h2>Why Choose Us?</h2>
                        <h1 style={{ fontSize: '2.4rem' }}>Best Value Deals Around</h1>
                        <div className="line" />
                        <h3 className="light" style={{ color: "#505050", paddingTop: 15, paddingBottom: 15 }}>Discover the best deals you'll ever find with our unbeatable offers. We're dedicated to providing you with the best value for your money, so you can enjoy top-quality services and products without breaking the bank. Our deals are designed to give you the ultimate renting experience, so don't miss out on your chance to save big.</h3>
                        <Button href="#reviews" variant="contained" color="primary" sx={{
                            p: 2, px: '2rem', '&:hover': {
                                backgroundColor: '#FF4D30',
                                color: 'white',
                            }
                        }}> Discover More</Button>
                    </Grid>
                    <Grid item x={12} sm={5}>
                        <Grid container direction={"row"} sx={{ alignItems: "center" }}>
                            <Grid item xs={6}>
                                <div style={{ display: 'flex', width: '200px', height: '200px', backgroundImage: `url(${blob})`, backgroundSize: '100%', justifyContent: "center", alignItems: 'center', transform: 'rotate(30deg)' }}>
                                    <CarRentalOutlinedIcon color="primary" sx={{ fontSize: 60, transform: 'rotate(-30deg)' }} />
                                </div>
                            </Grid>
                            <Grid item xs={6} sx={{ alignItems: "center" }}>
                                Cross Country Trips
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ display: 'flex', width: '200px', height: '200px', backgroundImage: `url(${blob})`, backgroundSize: '100%', justifyContent: "center", alignItems: 'center', transform: 'rotate(180deg)' }}>
                                    <PhoneForwardedOutlinedIcon color="primary" sx={{ fontSize: 60, transform: 'rotate(-180deg)' }} />
                                </div>
                            </Grid>
                            <Grid item xs={6} sx={{ alignItems: "center" }}>
                                24/7 Customer Support
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ display: 'flex', width: '200px', height: '200px', backgroundImage: `url(${blob})`, backgroundSize: '100%', justifyContent: "center", alignItems: 'center', transform: 'rotate(60deg)' }}>
                                    <MinorCrashOutlinedIcon color="primary" sx={{ fontSize: 60, transform: 'rotate(-60deg)' }} />
                                </div>
                            </Grid>
                            <Grid item xs={6} sx={{ alignItems: "center" }}>
                                Roadside Assistance
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </div >
    )
}

export default Choose